var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentageSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98003 8.08003C8.48297 8.08003 8.08003 8.48297 8.08003 8.98003C8.08003 9.47709 8.48297 9.88003 8.98003 9.88003C9.47709 9.88003 9.88003 9.47709 9.88003 8.98003C9.88003 8.48297 9.47709 8.08003 8.98003 8.08003ZM6.28003 8.98003C6.28003 7.48886 7.48886 6.28003 8.98003 6.28003C10.4712 6.28003 11.68 7.48886 11.68 8.98003C11.68 10.4712 10.4712 11.68 8.98003 11.68C7.48886 11.68 6.28003 10.4712 6.28003 8.98003Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.18 15.28C15.683 15.28 15.28 15.6829 15.28 16.18C15.28 16.677 15.683 17.08 16.18 17.08C16.6771 17.08 17.08 16.677 17.08 16.18C17.08 15.6829 16.6771 15.28 16.18 15.28ZM13.48 16.18C13.48 14.6888 14.6889 13.48 16.18 13.48C17.6712 13.48 18.88 14.6888 18.88 16.18C18.88 17.6711 17.6712 18.88 16.18 18.88C14.6889 18.88 13.48 17.6711 13.48 16.18Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6793 6.43104C17.0929 6.70675 17.2046 7.26554 16.9289 7.67911L9.7289 18.4791C9.45318 18.8927 8.8944 19.0044 8.48082 18.7287C8.06725 18.453 7.95549 17.8942 8.23121 17.4807L15.4312 6.68065C15.7069 6.26707 16.2657 6.15532 16.6793 6.43104Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.58 2.95996C7.26704 2.95996 2.96002 7.26698 2.96002 12.58C2.96002 17.8929 7.26704 22.2 12.58 22.2C17.893 22.2 22.2 17.8929 22.2 12.58C22.2 7.26698 17.893 2.95996 12.58 2.95996ZM0.960022 12.58C0.960022 6.16241 6.16247 0.959961 12.58 0.959961C18.9976 0.959961 24.2 6.16241 24.2 12.58C24.2 18.9975 18.9976 24.2 12.58 24.2C6.16247 24.2 0.960022 18.9975 0.960022 12.58Z",
    fill: "#FFC107"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentageSvg);
export default __webpack_public_path__ + "static/media/PercentageSvg.7ddcdb4b5724088960386b1a965e93e1.svg";
export { ForwardRef as ReactComponent };